import { toast } from "react-toastify";
import React from "react";
import { Button, Box, Typography } from "@mui/material";

export const useConfirm = () => {
  const confirm = (message) =>
    new Promise((resolve) => {
      const toastId = toast(
        <Box>
          <Typography fontWeight="bold" mb={2}>
            {message}
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                toast.dismiss(toastId);
                resolve(true);
              }}
              sx={{fontWeight:"bold"}}
            >
              ยืนยัน
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                toast.dismiss(toastId);
                resolve(false);
              }}
              sx={{fontWeight:"bold"}}
            >
              ยกเลิก
            </Button>
          </Box>
        </Box>,
        {
          style: {
            backgroundColor: "#eceff3ff", // <-- your color here
            color: "#363434ff",
            borderRadius: "10px",
            padding: "15px",
          },
          position: "top-center",
          autoClose: false,
          closeOnClick: false,
          draggable: false,
        }
      );
    });
  return { confirm };
};
